import { render, staticRenderFns } from "./major-code-reference.vue?vue&type=template&id=5886e6a5&scoped=true"
import script from "./major-code-reference.vue?vue&type=script&lang=js"
export * from "./major-code-reference.vue?vue&type=script&lang=js"
import style0 from "./major-code-reference.vue?vue&type=style&index=0&id=5886e6a5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5886e6a5",
  null
  
)

export default component.exports